import { render, staticRenderFns } from "./SynonymListItems.vue?vue&type=template&id=3c1e14dc&scoped=true&"
import script from "./SynonymListItems.vue?vue&type=script&lang=js&"
export * from "./SynonymListItems.vue?vue&type=script&lang=js&"
import style0 from "./SynonymListItems.vue?vue&type=style&index=0&id=3c1e14dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1e14dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c1e14dc')) {
      api.createRecord('3c1e14dc', component.options)
    } else {
      api.reload('3c1e14dc', component.options)
    }
    module.hot.accept("./SynonymListItems.vue?vue&type=template&id=3c1e14dc&scoped=true&", function () {
      api.rerender('3c1e14dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/SynonymList/components/common/SynonymListItems.vue"
export default component.exports